import { useState, useEffect } from "react";
import "./SlideShow.css";

function SlideShow() {
  const imagesUrl = ["./music/hanabi.jpg", "./music/kokuhaku.jpg", "./music/sakebu.jpg", "./music/hosizora.jpg"];
  const title=["花火","告白","叫ぶ","星空に願いを"];
  const caption=[
    "ドンと花火が上がる、君は―",//花火
    "この気持ちに嘘なんてつかずに、大好きだと伝えられたらな―",//告白
    "だけども僕らは、生きなきゃいけない。",//叫ぶ
    "君が指さす先、流れ星一つ。"//星空に願いを
];
const url=[
    "https://youtu.be/3U5ZkFKm0fE?si=FhruLIEXNwPuxmS1",
    "https://youtu.be/bt4TB0F4Duw?si=wgBR5TPgPtzOA1DC",
    "https://youtu.be/jS741f32-Ss?si=7dNKr47f1I3bm_6a",
    "https://youtu.be/CcSkMuRFFG4?si=_pCuy8J2nWWaQGzN"
]
  
  
  
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imagesUrl.length);
    }, 7000);

    return () => clearInterval(interval);
  }, [imagesUrl.length]);

  return (
    <>
    <div className="slideShow">
    <h1>OverView</h1>
    <span>画像をクリックすると、youtubeの楽曲ページに飛びます。</span>
    <a href={url[currentIndex]} target="_blank" rel="noopener noreferrer" className="linkToSong">
    <img src={imagesUrl[currentIndex]} alt="slideshow" className="slideShowImage"/>
    <div className="slideShowText">
    <h3 className="songTitle">{title[currentIndex]}</h3>
    <p className="songCaption">{caption[currentIndex]}</p>
    </div>
    </a>
    </div>
    </>
  );
}

export default SlideShow;